import { useGlobalStore } from "@/stores/global";
import darkBackIcon from "@/assets/images/newer/icon-back-dark.svg";
import backIcon from "@/assets/images/newer/icon-back.svg";
export const useColor = ()=>{
    const { theme } = useGlobalStore();
    const color = useMemo(()=>{
        const hasLight = theme === "0";
        return {
            text: hasLight ? "#59595E" : "#A4AEAE",
            arrow: hasLight ? backIcon.src : darkBackIcon.src
        };
    }, [
        theme
    ]);
    return {
        color
    };
};
